import { SET_FEATURES, FeatureFlags } from './types';

export const setFeatures = (features: FeatureFlags) => {
    return {
        type: SET_FEATURES,
        payload: features,
    };
};
